export const channelSetupConstants = {
    CHANNEL_SETUP_GET_PENDING  : 'CHANNEL_SETUP_GET_PENDING',
    CHANNEL_SETUP_GET_FULFILLED: 'CHANNEL_SETUP_GET_FULFILLED',
    CHANNEL_SETUP_GET_REJECTED : 'CHANNEL_SETUP_GET_REJECTED',

    CHANNEL_SETUP_ADD_PENDING  : 'CHANNEL_SETUP_ADD_PENDING',
    CHANNEL_SETUP_ADD_FULFILLED: 'CHANNEL_SETUP_ADD_FULFILLED',
    CHANNEL_SETUP_ADD_REJECTED : 'CHANNEL_SETUP_ADD_REJECTED',
}
